<div class="overlay min-h-10 bg-principal absolute" [ngClass]="{'active': visible(), 'disable': !visible()}">
  <ng-content></ng-content>
</div>
